<script>
  import Avatar from '@components/Avatar.svelte';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import Text from '@components/Text.svelte';

  export let result;
  export let mobile;
  export let handleClick;
</script>

<style style="text/scss" lang="scss">
  .flex-item {
    display: flex;
  }

  .avatar-wrapper {
    cursor: pointer !important;
  }
  .search-result {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    color: inherit !important;
    font-size: 13px;
    cursor: pointer !important;
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 10px 16px;

    &.mobile {
      padding-left: 20px;
      padding-right: 20px;
    }

    .user-info {
      flex-direction: column;
      margin-left: 4px;
      vertical-align: middle;
      justify-content: center;
      margin-right: 30px;
      cursor: pointer !important;
      .name {
        cursor: pointer;
        font-weight: 500;
        line-height: 20px;
        height: 20px;
        color: black;
        cursor: pointer !important;
      }

      .username {
        font-weight: regular;
        color: gray;
        cursor: pointer !important;
      }
    }
  }
</style>

<div class="search-result ck-reset_all-excluded {mobile ? 'mobile' : 'desktop'}" on:click={handleClick}>
  <div class="avatar-wrapper">
    <Avatar width={40} height={40} src={result.avatar_url} href={result.profile_path} user={result} mobile={mobile} />
  </div>
  <div class="flex-item user-info">
    <span class="name">
      <AccountVerifiedIcon dimension={16} verified={result.verified} on:areaClicked={handleClick}>
        <svelte:fragment slot="account-name">
          <Text lines={1} text={result.name} expand={false} />
        </svelte:fragment>
      </AccountVerifiedIcon>
    </span>
    <span class="username">
      <Text lines={1} text={result.username} expand={false} />
    </span>
  </div>
</div>
